import React from 'react';
import { string, func } from 'prop-types';

import useStyles from 'hooks/useStyles';
import Button from 'components/Button';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './RatingAction.scss';

const RatingAction = ({ title, actionText, onClickRating }) => {
  useStyles(styles);

  return (
    <div className={styles.rating}>
      <span className={styles.ratingTitle}>{title}</span>
      <Button
        className={styles.ratingButton}
        text={actionText}
        onClick={onClickRating}
        small
      />
    </div>
  );
};

RatingAction.propTypes = {
  title: string.isRequired,
  actionText: string.isRequired,
  onClickRating: func.isRequired,
};

export default RatingAction;
